import type { AnalyticsData } from './types.tsx';

// set

export const SET = 'analytics.SET' as const;
export type SetPayload = AnalyticsData;
export type SetAction = {
	type: typeof SET;
	payload: SetPayload;
};
export const set = (payload: SetPayload): SetAction => ({
	type: SET,
	payload,
});
